import authService from '@/authentication/authentication.service';
import { computed } from 'vue';
import { ConnectClaim } from '@/authentication/claims';

export function useAuth() {
  return {
    userName: computed(() => authService.getUserName()),
    userId: computed(() => authService.getClaim(ConnectClaim.UserId)),
    isAuthenticated: computed(() => authService.isAuthenticated()),
    isPlatformAdmin: computed(() => authService.getClaim(ConnectClaim.IsPlatformAdmin)),
    logout: () => authService.logout(),
  };
}
